const paymentConfig = {
  preferred_bank_for_payments: "Preferred Bank for Payments",
  payment_configurations: `Payment configuration`,
  bill_creation_email: `Send email when a new bill is created`,
  due_invoice_email: `Send reminder email when an invoice is due (Daily)`,
  configuration_updated_successfully: `Configuration updated successfully`,
};

export default paymentConfig;
